// extracted by mini-css-extract-plugin
export default {"avatar-group":"fNsPd","avatar-group_wrap":"fiG5I","avatar-group__item":"dMui7"};